const getPredefinedPictures = () => {
  return Array.from(Array(32)).map(
    (_, i) => `https://d39f3649v0o5oc.cloudfront.net/pictures/${i + 101}.jpg`
  );
};

export default getPredefinedPictures;
